import { render, staticRenderFns } from "./CompanyNotificationDelayConfiguration.vue?vue&type=template&id=2bf6a558&scoped=true"
import script from "./CompanyNotificationDelayConfiguration.vue?vue&type=script&lang=js"
export * from "./CompanyNotificationDelayConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf6a558",
  null
  
)

export default component.exports